import React from 'react';
import { Link } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { FaInstagram, FaLinkedinIn, FaEnvelope, FaArrowUp } from 'react-icons/fa';
import logo from '../assets/images/smg_logo.png';
import hidevLogo from '../assets/images/hidev_logo.png';
import './Footer.css';
import IconWrapper from './IconWrapper';

const Footer: React.FC = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-logo">
            <div className="logo-bubble">
              <img src={logo} alt="The Collective at Gateway Logo" />
            </div>
            <p>Premium flexible office space solutions at 1810 Gateway Dr, San Mateo, CA 94404.</p>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li>
                {isHomePage ? (
                  <Link to="home" smooth={true} duration={500}>Home</Link>
                ) : (
                  <RouterLink to="/">Home</RouterLink>
                )}
              </li>
              <li>
                {isHomePage ? (
                  <Link to="spaces" smooth={true} duration={500}>Spaces</Link>
                ) : (
                  <RouterLink to="/#spaces">Spaces</RouterLink>
                )}
              </li>
              <li>
                {isHomePage ? (
                  <Link to="amenities" smooth={true} duration={500}>Amenities</Link>
                ) : (
                  <RouterLink to="/#amenities">Amenities</RouterLink>
                )}
              </li>
              <li>
                {isHomePage ? (
                  <Link to="gallery" smooth={true} duration={500}>Gallery</Link>
                ) : (
                  <RouterLink to="/#gallery">Gallery</RouterLink>
                )}
              </li>
              <li>
                {isHomePage ? (
                  <Link to="contact" smooth={true} duration={500}>Contact</Link>
                ) : (
                  <RouterLink to="/#contact">Contact</RouterLink>
                )}
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
            <p>1810 Gateway Dr, San Mateo, CA 94404</p>
            <p>Phone: (650) 302-3011</p>
            <p>Email: <a href="mailto:smg@scpropsm.com">smg@scpropsm.com</a></p>
          </div>

          <div className="footer-powered">
            <h4>Powered By</h4>
            <div className="powered-logo">
              <a href="https://hidevmobile.com" target="_blank" rel="noopener noreferrer">
                <img src={hidevLogo} alt="HiDev Logo" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} The Collective at Gateway. All rights reserved.</p>
          </div>

          <div className="social-links">
            <a href="https://www.instagram.com/scproperties/" target="_blank" rel="noopener noreferrer">
              <IconWrapper icon={FaInstagram} />
            </a>
            <a href="https://www.linkedin.com/in/chris-giotinis-59753536/" target="_blank" rel="noopener noreferrer">
              <IconWrapper icon={FaLinkedinIn} />
            </a>
            <a href="mailto:smg@scpropsm.com">
              <IconWrapper icon={FaEnvelope} />
            </a>
          </div>

          <div className="back-to-top" onClick={scrollToTop}>
            <IconWrapper icon={FaArrowUp} />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 